import { render, staticRenderFns } from "./SummaryItems.vue?vue&type=template&id=520eef8e&"
import script from "./SummaryItems.vue?vue&type=script&lang=js&"
export * from "./SummaryItems.vue?vue&type=script&lang=js&"
import style0 from "./SummaryItems.vue?vue&type=style&index=0&id=520eef8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports